import {useRef} from 'react'

import Style from './style'

import MainHeader from 'widget/MainHeader'

import useGetMyFranchise from 'entity/franchise/useGetMyFranchise'
import usePostImgUpload from 'entity/util/usePostImgUpload'
import usePutMyFranchise from 'entity/franchise/usePutMyFranchise'

import CStyle from 'shared/style/commonStyle'
import ITStyle from 'shared/style/inputTableStyle'
import DefaultButton from 'shared/ui/DefaultButton'

const MyFranchiseEdit = () => {
	const nameRef = useRef()
	const addressRef = useRef()
	const contactRef = useRef()
	const storeTicketNameRef = useRef()
	const imgRef = useRef()

	const [myFranchiseData] = useGetMyFranchise()
	const [imgState, uploadImgEvent, deleteImg] = usePostImgUpload(
		myFranchiseData?.data?.franchise_manager?.franchise_logo_img
	)
	const [putMyFranchise] = usePutMyFranchise(
		nameRef,
		contactRef,
		addressRef,
		storeTicketNameRef,
		imgState
	)

	const btnList = [
		{
			label: '저장',
			clickEvent: () => putMyFranchise(),
			deactive: false,
		},
	]

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList} title='프랜차이즈 정보 수정' />

			<ITStyle.TableDiv>
				<ITStyle.TableElement>
					<h2>
						프랜차이즈 이름<span>*</span>
					</h2>
					<input
						ref={nameRef}
						placeholder='40글자 이하'
						defaultValue={
							myFranchiseData?.data?.franchise_manager?.franchise_name
						}
					/>
				</ITStyle.TableElement>
				<ITStyle.TableElement>
					<h2>
						대표 연락처<span>*</span>
					</h2>
					<input
						ref={contactRef}
						placeholder="'-' 없이 숫자만 입력"
						defaultValue={
							myFranchiseData?.data?.franchise_manager?.franchise_contact
						}
					/>
				</ITStyle.TableElement>
				<ITStyle.TableElement>
					<h2>
						대표 주소<span>*</span>
					</h2>
					<input
						ref={addressRef}
						defaultValue={
							myFranchiseData?.data?.franchise_manager?.franchise_address
						}
					/>
				</ITStyle.TableElement>
				<ITStyle.TableElement>
					<h2>
						매장 이용권 이름<span>*</span>
					</h2>
					<input
						ref={storeTicketNameRef}
						placeholder='40글자 이하'
						defaultValue={
							myFranchiseData?.data?.franchise_manager?.store_ticket_name
						}
					/>
				</ITStyle.TableElement>
			</ITStyle.TableDiv>

			<Style.AreaDiv>
				<h2>
					프랜차이즈 로고 이미지<span>*</span>
				</h2>
				<CStyle.GuideDiv>
					<p>JPG, PNG 이미지 | 10MB 제한</p>
					<p>1:1 비율의 이미지에 가장 최적화 되어 있습니다.</p>
				</CStyle.GuideDiv>
				<DefaultButton small fitWidth clickEvent={() => imgRef.current.click()}>
					첨부하기
				</DefaultButton>
				<input
					type='file'
					ref={imgRef}
					onChange={uploadImgEvent}
					style={{display: 'none'}}
				/>

				{imgState && (
					<Style.ImgUploadDiv>
						<Style.ImgElement>
							<button onClick={deleteImg}>삭제</button>
							<img
								src={imgState}
								onClick={() => window.open(imgState, '_blank')}
							/>
						</Style.ImgElement>
					</Style.ImgUploadDiv>
				)}
			</Style.AreaDiv>
		</Style.Wrapper>
	)
}

export default MyFranchiseEdit
